module.exports = __webpack_public_path__ + "media/images/lp_banner_600_500_B-a88e0800b58f1fca723903952a8adb8c.webp";